import fetch from '@/common/fetch';
import { apiName } from '@/api/index';

const path = `${apiName}/public`;

// annoucement_list
const annoucementlist = `${path}/sysMsgOrNotice`;
// signin
const signinurl = `${path}/signin`;
// 上传图片
const upload_imageurl = `${path}/upload_image`;
// 合作伙伴
const partnerapply_url = `${path}/partnerapply`;
// 手机验证码
const tel_vericode_url = `${path}/tel_vericode`;
// 国家
const country_url = `${path}/country`;
// 注册
const signup_url = `${path}/signup`;
// 邮箱验证码
const mail_url = `${path}/mail_vericode`;
// cur
const cur_url = `${path}/cur`;
// ins
const ins_url = `${path}/ins`;
const biz_url = `${path}/biz`;
// const match_ins_listurl = `${path}/match_ins_list`;

const match_ins_listurl = `${path}/match_ins_list`;
const resetpwduri = `${path}/resetpwd`;
const vrfinvitecodeuri = `${path}/vrfinvitecode`;
const appveruri = `${path}/appver`;

// 鱼泡 start
// 发送手机验证码
const sendsms_url = `${path}/bb_sendsms`;
// 验证码注册
const signupverifycode_url = `${path}/bb_signupverifycode`;
// 历史记录
const mm_activity_draw_history_url = `${path}/mm_activity_draw_history`;
// 历史记录
const mm_activity_draw_user_list_url = `${path}/mm_activity_draw_user_list`;


// 鱼泡end




// 鱼泡 start
const getSendsms = data => (fetch({
  url: sendsms_url,
  method: 'post',
  data,
}));
const getSignupverifycode = data => (fetch({
  url: signupverifycode_url,
  method: 'post',
  data,
}));
const mmActivityDrawHistory = data => (fetch({
  url: mm_activity_draw_history_url,
  method: 'post',
  data,
}));
const mmActivityDrawUserList = data => (fetch({
  url: mm_activity_draw_user_list_url,
  method: 'post',
  data,
}));
// 鱼泡 end


const getappver = data => (fetch({
  url: appveruri,
  method: 'post',
  data,
}));
const gitbiz = data => (fetch({
  url: biz_url,
  method: 'post',
  data,
}));
const vrfinvitecode = data => (fetch({
  url: vrfinvitecodeuri,
  method: 'post',
  data,
}));
const resetpwd = data => (fetch({
  url: resetpwduri,
  method: 'post',
  data,
}));
const getmatchlisturl = data => (fetch({
  url: match_ins_listurl,
  method: 'post',
  data,
}));

const getinsdata = data => (fetch({
  url: ins_url,
  method: 'post',
  data,
}));
const signup = data => (fetch({
  url: signup_url,
  method: 'post',
  data,
}));
const getcur = data => (fetch({
  url: cur_url,
  method: 'post',
  data,
}));
const getmailvericode = data => (fetch({
  url: mail_url,
  method: 'post',
  data,
}));
const getannoucementlist = data => (fetch({
  url: annoucementlist,
  method: 'post',
  data,
}));
const getcountry = data => (fetch({
  url: country_url,
  method: 'post',
  data,
}));
const gettevericode = data => (fetch({
  url: tel_vericode_url,
  method: 'post',
  data,
}));
const signin = data => (fetch({
  url: signinurl,
  method: 'post',
  data,
}));
const sendImg = data => (fetch({
  url: upload_imageurl,
  method: 'post',
  data,
}));
const addPartnerapply = data => (fetch({
  url: partnerapply_url,
  method: 'post',
  data,
}));



export default {
  getinsdata,
  signup,
  getcur,
  resetpwd,
  getmailvericode,
  getannoucementlist,
  getcountry,
  gettevericode,
  signin,
  sendImg,
  addPartnerapply,
  getmatchlisturl,
  vrfinvitecode,
  gitbiz,
  getappver,
  getSendsms,
  getSignupverifycode,
  mmActivityDrawHistory,
  mmActivityDrawUserList
};



// WEBPACK FOOTER //
// ./src/api/public/index.js